<template>
  <new-group />
</template>

<script>
import NewGroup from "@/components/3pl/Settings/UsersAndGroups/Groups/NewGroup/index";
export default {
  components: {
    NewGroup,
  },
};
</script>

<style></style>
